// extracted by mini-css-extract-plugin
module.exports = {"floatingEntry":"ConferenceChatFloatingEntry_floatingEntry__z387I","label":"ConferenceChatFloatingEntry_label__n7khA","icon":"ConferenceChatFloatingEntry_icon__qgQ8u"};